import React, { useState, useEffect } from "react";
import { Modal, Button, Form, Collapse } from "react-bootstrap";
import "./FilterModal.css";
import { FaAngleDown, FaFilter, FaAngleUp } from "react-icons/fa";
import ClearFilters from "../../../assets/icons/ClearFilters.svg";

const FilterModal = ({ filterConfig, onApplyFilters, triggerComponent }) => {
    const [show, setShow] = useState(false);
    const [filters, setFilters] = useState(
        filterConfig.reduce((acc, curr) => {
            acc[curr.name] = Array.isArray(curr.value) ? curr.value : (curr.value ? [curr.value] : []);
            return acc;
        }, {})
    );
    const [openCollapse, setOpenCollapse] = useState({});
    const [_searchTerm, setSearchTerm] = useState("");

    //reset filters when filterConfig changes
    useEffect(() => {
        setFilters(
            filterConfig.reduce((acc, curr) => {
                acc[curr.name] = Array.isArray(curr.value) ? curr.value : (curr.value ? [curr.value] : []);
                return acc;
            }, {})
        );
    }, [filterConfig]);

    const handleShow = () => setShow(true);

    const handleClose = () => {
        clearFilters();
        setOpenCollapse({});
        setShow(false);
    };

    const handleChange = (option, field) => {
        setFilters((prev) => {
            let newSelections;
            if (field.name === "hiringDate" || field.name === "createdAt" || field.name === "teamCreatedAt") {
                if (prev[field.name]?.includes(option)) {
                    newSelections = [];
                } else {
                    newSelections = [option];
                }
            } else {
                const currentSelections = prev[field.name] || [];
                if (currentSelections.includes(option)) {
                    newSelections = currentSelections.filter(item => item !== option);
                } else {
                    newSelections = [...currentSelections, option];
                }
            }
            return {
                ...prev,
                [field.name]: newSelections,
            };
        });
    };

    const clearFilters = () => {
        setFilters(
            filterConfig.reduce((acc, curr) => {
                acc[curr.name] = [];
                return acc;
            }, {})
        );
        setSearchTerm("");
    };

    const applyFilters = () => {
        onApplyFilters(filters);
        setOpenCollapse({});
        setShow(false);
    };

    const toggleCollapse = (fieldName) => {
        setOpenCollapse(prevState => ({
            ...prevState,
            [fieldName]: !prevState[fieldName],
        }));
    };

    const handleClear = () => {
        clearFilters();
        onApplyFilters(
            filterConfig.reduce((acc, curr) => {
                acc[curr.name] = Array.isArray(curr.value) ? [] : "";
                return acc;
            }, {})
        );
        setShow(false);
    };

    return (
        <>
            <div className="trigger-container" onClick={handleShow}>
                {triggerComponent ? (
                    triggerComponent
                ) : (
                    <div className="trigger-button">
                        <FaFilter size={20} fill="#ffffff" />
                    </div>
                )}
            </div>
            <Modal show={show} onHide={handleClose} centered backdrop="static" className="modal-overlay border-0">
                <Modal.Header closeButton closeVariant="white" className="modal-header-custom">
                    <div className="d-flex w-100 justify-content-between align-items-center">
                        <Modal.Title className="text-white fw-bold ms-2 fs-2">Filtrar</Modal.Title>
                        <img src={ClearFilters} alt="clearout" size={22} className="text-white me-3 eraser-icon" role="button" onClick={handleClear} title="Limpar Filtros" />
                    </div>
                </Modal.Header>
                <Modal.Body className="modal-body-custom">
                    <Form>
                        {filterConfig.map((field, index) => {
                            const isFirst = index === 0;
                            const isLast = index === filterConfig.length - 1;
                            return (
                                <Form.Group key={field.name} className="mb-0 filter-group">
                                    <div className="position-relative">
                                        <div
                                            className={`d-flex justify-content-between align-items-center filter-header 
                                                ${isFirst ? "first" : ""} 
                                                ${isLast ? "last" : ""}`}
                                            onClick={() => toggleCollapse(field.name)}
                                        >
                                            <h5 className="text-white">{field.label}</h5>
                                            {openCollapse[field.name] ? (
                                                <FaAngleUp size={25} fill="#ffffff" />
                                            ) : (
                                                <FaAngleDown size={25} fill="#ffffff" />)}
                                        </div>
                                        <Collapse in={openCollapse[field.name]}>
                                            <div className={`filter-options ${isLast ? "last" : ""}`}>
                                                {field.options.map((option, idx) => (
                                                    <Form.Check
                                                        key={idx}
                                                        type="checkbox"
                                                        id={`${field.name}-${option}`}
                                                        name={field.name}
                                                        label={option}
                                                        value={option}
                                                        checked={filters[field.name]?.includes(option)}
                                                        onChange={() => handleChange(option, field)}
                                                        className="text-white"
                                                    />
                                                ))}
                                            </div>
                                        </Collapse>
                                    </div>
                                </Form.Group>
                            );
                        })}
                    </Form>
                </Modal.Body>
                <Modal.Footer className="modal-footer-custom">
                    <div className="d-flex w-100">
                        <Button variant="secondary" onClick={handleClose} className="flex-fill me-2 cancel-button rounded-3">
                            Cancelar
                        </Button>
                        <Button variant="primary" onClick={applyFilters} className="flex-fill apply-button rounded-3">
                            Aplicar
                        </Button>
                    </div>
                </Modal.Footer>
            </Modal>
        </>
    );
};

export default FilterModal;